<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardHeader>
          <CCol>
            <strong>{{ $lang.need.crud.detail }}</strong>
            <back-to-list></back-to-list>
          </CCol>
        </CCardHeader>
        <CCardBody>
          <CTabs add-tab-classes="mt-1">
            <span @click="selected = 'NeedEdit'">
              <CTab>
                <template slot="title">
                  {{ $lang.need.crud.detail }}
                </template>
              </CTab>
            </span>
            <span @click="selected = 'NeedResponse'">
              <CTab>
                <template slot="title">
                  {{ $lang.need.crud.opportunity_resource }}
                </template>
              </CTab>
            </span>
            <span @click="selected = 'NeedReport'">
              <CTab>
                <template slot="title">
                  {{ $lang.need.crud.view_report }}
                </template>
              </CTab>
            </span>
          </CTabs>
          <component
              :is="selected"
              @changeSelected="getTab($event)"
              style="margin-top: 20px"
          ></component>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import {Mixin} from "/src/mixins/index.js";
import NeedEdit from "./tab/NeedEdit";
import NeedReport from "./tab/NeedReport";
import NeedResponse from "./tab/NeedResponse";
import BackToList from "/src/views/backToList.vue";

export default {
  name: "NeedView",
  mixins: [Mixin],
  components: {
    NeedEdit,
    NeedReport,
    NeedResponse,
    BackToList,
  },
  data() {
    return {
      userId: "",
      tabs: ["NeedEdit", "NeedReport", "NeedResponse"],
      selected: "NeedEdit",
      currentId: "",
      backToListFlag: "",
    };
  },
  mounted() {
    let self = this;
    const id = this.$route.params.id;
    self.userId = this.$route.params.ids;
    self.currentId = id;
  },
  methods: {
    backToList(userId) {
      if (userId != null) {
        this.$router.push({path: "/profile/all/" + userId});
      }
    },
    getTab(tab) {
      let self = this;
      self.selected = tab;
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
